var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.94 2.30357C19.2882 2.00395 18.5242 2.13044 17.9985 2.625L15.7421 4.76786V3.21429C15.7421 1.43908 14.3325 0 12.5937 0H3.14843C1.4096 0 0 1.43908 0 3.21429V11.7857C0 13.5609 1.4096 15 3.14843 15H12.5937C14.3325 15 15.7421 13.5609 15.7421 11.7857V10.2321L18.009 12.375C18.3427 12.6834 18.7763 12.8551 19.2264 12.8571C19.4762 12.8565 19.723 12.8018 19.9505 12.6964C20.5837 12.4349 20.9986 11.808 21 11.1107V3.88929C20.9969 3.18936 20.5773 2.56166 19.94 2.30357ZM14 11.9C14 12.5075 13.5116 13 12.9091 13H3.09091C2.48842 13 2 12.5075 2 11.9V3.1C2 2.49249 2.48842 2 3.09091 2H12.9091C13.5116 2 14 2.49249 14 3.1V11.9ZM16 8L19 11V5L16 8Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetVideo);
export default __webpack_public_path__ + "static/media/getVideo.c9a77fad41a33fb549640c1b71405fa3.svg";
export { ForwardRef as ReactComponent };